import React, { useEffect, useRef, useState } from 'react'
import NetaqInput from './NetaqInput';
import UploadFile from './UploadFile';
import SignaturePad from "react-signature-canvas";
import axiosInstance from '../axios/axios';
import EahsForm from './EahsForm';
import { eformCheckBox, eformInput, eformTerms, saveBtnInProfile } from '../common/cssclasses';
import NewActionButton from './ActionButtons/NewActionButton';
import CustomSecondPopUp from './CustomSecondPopUp';
import OwnerPermisions from './OwnerPermisions';
import SimpleUpload from "./SimpleFileUpload";

export default function AccountSetting({
    translate,
    englishName,
    ownerAppuserByIdData,
    setEnglishName,
    arabicName,
    setArabicName,
    email,
    userIsUAEPass,
    setEmail,
    phoneNo,
    setPhoneNo,
    userProfile,
    secondEmail,
    setSecondEmail,
    ownerPhoneNo,
    setOwnerPhoneNo,
    mobileNo,
    setMobileNo,
    handleFileChange,
    imageURL,
    handelUpdateOwnerAppuserAccount,
    handelChangePassword,
    setOldPassword,
    showErrorConfirmPassword,
    setConfirmNewPassword,
    setConfirmPassword,
    bankName,
    setBankName,
    setImageURL,
    iban,
    setIban,
    swiftCode,
    setSwiftCode,
    bankAccountNumber,
    setBankAccountNumber,
    bneficiaryName,
    setBneficiaryName,
    bankCountry,
    setBankCountry,
    curency,
    setCurency,
    cachedUserProfile,
    toast,
    reloadProfile,
    setActiveTab,
    setIsAgent,
    setIsHandler,
    isAgent = false,
    isHandler = false,
    uploadedHandlerCertificate,
    setUploadedHandlerCertificate,
    handleHandlerCertificateUploaded,
    profileImageFile,
    setProfileImageFile,
    handleProfileImageFileUploaded,
    uploadedNationalIdFile,
    setUploadedNationalIdFile,
    handleNationalIdFileUploaded,
    trn,
    setTrn,
    trc,
    setTrc,
    hasTrn,
    setHasTrn,
}) {

    const [invalidIban, setInvalidIBAN] = useState(false);
    const [curenciesOptions, setCurenciesOptions] = useState([]);
    const [nationalityOptions, setNationalityOptions] = useState([]);
    const signatureCanvas = useRef(null);
    const onSaveSignature = (onCloseSignaturePad) => {
        if (!signatureCanvas.current?.isEmpty()) {
            const imageData = signatureCanvas.current
                .getTrimmedCanvas()
                .toDataURL("image/png");
            setImageURL(imageData);
        }
    };

    const onClearSignature = () => signatureCanvas?.current?.clear();

    async function getcurrencyList() {
        try {
            const currencylist = await axiosInstance.get('/lookup/getcurrencies');
            const formattedData = currencylist?.data?.result?.map((item) => ({
                ...item,
                label: item.text
            }))

            setCurenciesOptions(formattedData ?? []);
            if (cachedUserProfile != false) {
                const defaultCurrency = formattedData?.find(item => item.value == cachedUserProfile?.currencyId);
                if (defaultCurrency) {
                    setCurency(defaultCurrency);
                }
            }
        } catch (error) {
            console.error('error in currency list')
        }
    }

    async function getNationalityList() {
        try {
            const nationalityList = await axiosInstance.get('/nationality')
            const formattedData = await nationalityList.data.result.map((item) => ({
                text: item.name,
                label: item.name,
                value: item.id,
            }));
            setNationalityOptions(formattedData);
            if (cachedUserProfile != false) {
                const defaultCountry = formattedData?.find(item => item.value == cachedUserProfile?.bankCountryId);
                if (defaultCountry) {
                    setBankCountry(defaultCountry);
                }
            }
        } catch (error) {
            console.error('eror in getting countries')
        }
    }

    function setInitialValus() {
        if (!!ownerAppuserByIdData) {
            setEmail(ownerAppuserByIdData?.email);
            setPhoneNo(ownerAppuserByIdData?.mobileNo);
            setSecondEmail(ownerAppuserByIdData?.secondEmail);
            setMobileNo(ownerAppuserByIdData?.secondMobileNo);
            setOwnerPhoneNo(ownerAppuserByIdData?.phoneNo);

            console.log("account setting", ownerAppuserByIdData);

            setIsAgent(ownerAppuserByIdData?.isAgent);
            setIsHandler(ownerAppuserByIdData?.isHandler);
        }
    }

    useEffect(() => {
        getNationalityList();
        getcurrencyList();


    }, []);
    useEffect(() => {
        if (userProfile?.profileImage != null) {
            setProfileImageFile([{
                documentUrl: userProfile?.profileImage,
                file: userProfile?.profileImage,
                name: translate('web.myProfileImage', 'My Profile Image'),
            }])
        }
        if (userProfile?.profileImage != null) {
            setProfileImageFile([{
                documentUrl: userProfile?.profileImage,
                file: userProfile?.profileImage,
                name: translate('web.myProfileImage', 'My Profile Image'),
            }])
        }
        if (userProfile?.trcFile != null) {
            setTrc([{
                documentUrl: userProfile?.trcFile,
                file: userProfile?.trcFile,
                name: userProfile?.trcFileName,
            }])
        }
        setTimeout(() => {
            setHasTrn(userProfile?.hasTrn == false ? false : userProfile?.hasTrn == true ? true : null);
        }, 500);
        setTrn(userProfile?.trn ?? '');
    }, [userProfile])

    useEffect(() => {
        setInitialValus();
    }, [ownerAppuserByIdData])

    useEffect(() => {
        if (((iban?.length < 14 || iban?.length > 35) && (iban.length > 0)) ?? false) {
            setInvalidIBAN(true);
        } else {
            setInvalidIBAN(false);
        }
    }, [iban]);

    const userData = ownerAppuserByIdData;

    const isBasicAccount = userProfile?.accountType == "BasicAccount" ?? false;

    const disableSaveBasic = !email || !phoneNo;

    const disableSave = !email || !phoneNo || !secondEmail || !mobileNo || !ownerPhoneNo;

    function isServerFile(files = []) {
        if (files?.length > 0) {
            try {
                if (files[0]?.file?.startsWith('http')) {
                    return true
                } else {
                    return false
                }
            } catch (error) {
                return false
            }
        } else {
            return false;
        }
    }


    const handleUpload = (e, setData) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    // Check allowed file types
                    const file = e.target.files[fileIndex];
                    const allowedMimeTypes = ['image/', 'application/pdf'];

                    if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
                        toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
                        continue; // Skip to the next file if type is not allowed
                    }

                    fileListHook.push({
                        documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                        name: e.target.files[fileIndex].name,
                        file: e.target.files[fileIndex],
                    });
                }
            }
            setData(fileListHook);
        }
    };


    return <div className="col-lg-9 col-md-8 col-sm-12 rtl">
        <EahsForm isNoMargin className={'mb-main'} isform onSubmit={handelUpdateOwnerAppuserAccount} title={translate("web.userInfo", "user Info")}>
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    name={"English Name"}
                    placeholder={translate("web.englishName", "English Name")}
                    label={translate("web.englishName", "English Name")}
                    value={englishName !== ""
                        ? englishName
                        : !!ownerAppuserByIdData &&
                        ownerAppuserByIdData.fullName
                    }
                    disabled={true}
                    onChange={(e) => setEnglishName(e.target.value)} />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    name={"Arabic Name"}
                    placeholder={translate("web.arabicName", "Arabic Name")}
                    label={translate("web.arabicName", "Arabic Name")}
                    value={arabicName !== ""
                        ? arabicName
                        : !!ownerAppuserByIdData &&
                        ownerAppuserByIdData.fullNameAr
                    }
                    disabled={true}
                    onChange={(e) => setArabicName(e.target.value)} />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"email"}
                    name={"email"}
                    placeholder={translate("web.email", "Email")}
                    label={translate("web.email", "Email")}
                    value={email}
                    required
                    disabled={userIsUAEPass === "false" ? false : true}
                    onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    name={"mobile no"}
                    placeholder={translate("web.smsPhoneNo", "Mobile No")}
                    label={translate("web.smsPhoneNo", "Mobile No")}
                    disabled={userIsUAEPass === "false" ? false : true}
                    required
                    value={phoneNo}
                    onChange={(e) => setPhoneNo(e.target.value)} />
            </div>
            {!isBasicAccount && (
                <>
                    <div className={eformInput}>
                        <NetaqInput
                            type={"email"}
                            name={"second email"}
                            placeholder={translate(
                                "web.secondEmail",
                                "Second Email"
                            )}
                            label={translate("web.secondEmail", "Second Email")}
                            value={secondEmail}
                            onChange={(e) => setSecondEmail(e.target.value)}
                            required />
                    </div>
                    <div className={eformInput}>
                        <NetaqInput
                            type={"text"}
                            name={"phone no"}
                            placeholder={translate("web.phoneNo", "Phone No")}
                            label={translate("web.phoneNo", "Phone No")}
                            value={ownerPhoneNo}
                            required
                            onChange={(e) => setOwnerPhoneNo(e.target.value)} />
                    </div>
                    <div className={eformInput}>
                        <NetaqInput
                            type={"text"}
                            name={"second mobile no"}
                            placeholder={translate(
                                "web.secondMobileNo",
                                "Second Mobile No"
                            )}
                            label={translate(
                                "web.secondMobileNo",
                                "Second Mobile No"
                            )}
                            value={mobileNo}
                            required
                            onChange={(e) => setMobileNo(e.target.value)} />
                    </div>
                    <div className={eformInput} >
                        <label className="capatalize_text">
                            {translate('web.nationalIdFile', 'National Id File')}
                        </label>
                        <SimpleUpload
                            accept="image/*,application/pdf"
                            isMulti={false}
                            isServer={false}
                            initialFiles={uploadedNationalIdFile}
                            onChange={handleNationalIdFileUploaded}
                            key={'NATIONAL ID FILE'} />
                    </div>
                    <div className={eformInput} >
                        <label className="capatalize_text">
                            {translate('web.profileImage', 'Profile Image')}
                        </label>
                        <SimpleUpload
                            accept="image/*"
                            isMulti={false}
                            isServer={
                                isServerFile(profileImageFile)
                            }
                            initialFiles={profileImageFile}
                            onChange={handleProfileImageFileUploaded}
                            key={'Profile Id'} />
                    </div>

                    <div className={eformTerms}>
                        <div className="row mx-0">
                            <div className={eformCheckBox}>
                                <NetaqInput
                                    type={"checkbox"}
                                    label={translate(
                                        "web.iHaveHandlerCertificate",
                                        "I Have Handler Certificate"
                                    )}
                                    name="iHaveHandlerCertificate"
                                    disabled={cachedUserProfile?.isHandler == true}
                                    checked={isHandler}
                                    onChange={(e) => setIsHandler(e.target.checked)}
                                />
                            </div>
                        </div>
                    </div>

                    {isHandler && (cachedUserProfile?.isHandler == false) && (
                        <div className={'col-lg-6 mb-1 col-md-6 col-sm-12  rtl form-group'} >
                            <label className="capatalize_text">
                                {translate('web.handlerCertificate', 'Handler Certificate')}
                                <span className="color-eahsred">*</span>
                            </label>
                            <SimpleUpload
                                accept="image/*,application/pdf"
                                isMulti={false}
                                isServer={false}
                                initialFiles={uploadedHandlerCertificate}
                                onChange={handleHandlerCertificateUploaded}
                                key={'HANDLER CERTIFICATE'} />
                        </div>
                    )}
                </>
            )}
            <div className={eformInput + " ms-auto"} >
                <>
                    <label>{translate("web.signature", "Signature")}</label>
                    <div className='row'>
                        <CustomSecondPopUp
                            trigger={<div className="col-sm-5 col-12 mb-md-0 mb-sm-2 mb-2">
                                <div className='btn btn-dark'>
                                    {translate(
                                        "web.openSigniturePad",
                                        "Open Signiture Pad"
                                    )}
                                </div>
                            </div>}
                            onClear={onClearSignature}
                            onSave={onSaveSignature}
                        >
                            <SignaturePad
                                ref={signatureCanvas}
                                canvasProps={{
                                    className: "signatureCanvas",
                                }} />
                        </CustomSecondPopUp>
                        <div className="col-sm-2 col-12 text-center d-flex justify-content-center align-items-center">
                            {translate("web.or", "OR")}
                        </div>
                        {<div className="col-sm-5 col-12 mb-md-0 mb-sm-2 mb-2 text-end">
                            <UploadFile
                                text="Upload Singniture Photo"
                                onChange={handleFileChange} />
                        </div>}
                    </div>
                    <div

                        className="col-lg-12 col-md-12 col-sm-12 mt-3"
                    >
                        <div className="text-center">
                            {imageURL ||
                                (!!ownerAppuserByIdData &&
                                    !!ownerAppuserByIdData.signature) ? (
                                //(!!OwnerByIdData && !!OwnerByIdData.signature) ? (
                                <img
                                    src={imageURL || ownerAppuserByIdData.signature}
                                    //src={imageURL || OwnerByIdData.signature}
                                    alt={translate("web.signature", "Signature")}
                                    style={{
                                        width: "100%",
                                        maxWidth: 216,
                                        maxHeight: 216,
                                    }} />
                            ) : null}
                        </div>
                    </div>
                </>
            </div>

            <div>
                <div className={saveBtnInProfile}>
                    <NewActionButton
                        isButton
                        text={translate("web.save", "Save")}
                        disabled={isBasicAccount ? disableSaveBasic : false} />
                </div>
            </div>
        </EahsForm>

        <EahsForm isNoMargin title={translate("web.bankDetails", "Bank Details")} className="mb-main">
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    name={"BankName"}
                    placeholder={translate("web.bankName", "Bank Name")}
                    label={translate("web.bankName", "Bank Name")}
                    value={bankName}
                    onChange={(e) => setBankName(e.target.value)} />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    name={"bneficiaryName"}
                    placeholder={translate("web.bneficiaryName", "Beneficiary Name")}
                    label={translate("web.bneficiaryName", "Bneficiary Name")}
                    value={bneficiaryName}
                    onChange={(e) => setBneficiaryName(e.target.value)} />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    label={translate("web.iban", "IBAN")}
                    placeholder={translate("web.iban", "Iban")}
                    name={"iban"}
                    value={iban}
                    key={"IBAN"}
                    onChange={(e) => setIban(e.target.value)}
                />
                {invalidIban &&
                    <div className='text-danger text-center'>
                        {translate('web.invalidIban', 'Invalid IBAN')}
                    </div>
                }
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    name={"bankAccountNumber"}
                    placeholder={translate("web.BankAccountNumber", "Bank Account Number")}
                    label={translate("web.BankAccountNumber", "Bank Account Number")}
                    value={bankAccountNumber}
                    onChange={(e) => setBankAccountNumber(e.target.value)} />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    type={"text"}
                    name={"swiftCode"}
                    placeholder={translate("web.swiftCode", "SwiftCode")}
                    label={translate("web.swiftCode", "SwiftCode")}
                    value={swiftCode}
                    onChange={(e) => setSwiftCode(e.target.value)} />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    key={'bankCountryId'}
                    type={"select"}
                    label={translate("web.bankCountry", "Bank Country")}
                    placeholder={translate("web.bankCountry", "Bank Country")}
                    name={"bankCountryId"}
                    listSelect={nationalityOptions}
                    value={bankCountry}
                    onChange={(evt) => setBankCountry(evt)}

                />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    key={'currencyId'}
                    type={"select"}
                    label={translate("web.curency", "Curency")}
                    placeholder={translate("web.curency", "curency")}
                    name={"currencyId"}
                    listSelect={curenciesOptions}
                    value={curency}
                    onChange={(evt) => setCurency(evt)}

                />
            </div>

            <div className={saveBtnInProfile}>
                <NewActionButton
                    isButton
                    text={translate("web.save", "Save")}
                    onClick={handelUpdateOwnerAppuserAccount}
                    disabled={isBasicAccount ? disableSaveBasic : disableSave} />

            </div>

        </EahsForm>
        <EahsForm isNoMargin title={translate("web.trnDetails", "TRN Details")} className="mb-main">
            <label className="capatalize_text">
                {translate("web.registeredforVAT", "Are you registered for VAT with the Federal Tax Authority")}
            </label>
            <div className={eformInput}>
                <NetaqInput
                    key={'no'}
                    type='radio'
                    name={'hasTrn'}
                    label={translate('web.no', 'No')}
                    onClick={() => {
                        setHasTrn(false);
                    }}
                    onChange={(e) => {
                        setHasTrn(false);
                    }}
                />
            </div>
            <div className={eformInput}>
                <NetaqInput
                    key={'yes'}
                    type='radio'
                    name={'hasTrn'}
                    label={translate('web.yes', 'Yes')}
                    checked={hasTrn == true ? true : null}
                    onClick={() => {
                        setHasTrn(true);
                    }}
                    onChange={(e) => {
                        setHasTrn(true)
                    }}
                />
            </div>
            {!!hasTrn &&
                <>
                    <div className={eformInput}>
                        <NetaqInput
                            type={"text"}
                            name={"TRN"}
                            placeholder={translate("web.taxRegistrationNumber", "Tax Registration Number")}
                            label={translate("web.taxRegistrationNumber", "Tax Registration Number")}
                            value={trn}
                            required
                            onChange={(e) => setTrn(e.target.value)} />
                    </div>
                    <div className={eformInput}>
                        <label className="capatalize_text">
                            {translate("web.taxRegistrationCertificate", "Tax Registration Certificate")}
                            <span className="color-eahsred">*</span>
                        </label>
                        <SimpleUpload
                            accept="image/*,application/pdf"
                            isMulti={false}
                            isServer={!!userProfile?.trcFile}
                            initialFiles={trc}
                            onChange={(e) => handleUpload(e, setTrc)}
                            name={'TRCFile'}
                            key={'TRCFile'}
                        />
                    </div>
                </>
            }


            <div className={saveBtnInProfile}>
                <NewActionButton
                    isButton
                    text={translate("web.save", "Save")}
                    onClick={handelUpdateOwnerAppuserAccount}
                    disabled={false} />

            </div>

        </EahsForm>

        {userIsUAEPass === "false" && (
            <EahsForm
                isNoMargin
                title={translate("web.changePassword", "Change Password")}
                isform={true}
                onSubmit={handelChangePassword}
                className="mb-main"
            >
                <div className={eformInput}>
                    <NetaqInput
                        type={"password"}
                        name={"oldpassword"}
                        placeholder={translate(
                            "web.oldPassword",
                            "Old Password"
                        )}
                        label={translate("web.oldPassword", "Old Password")}
                        onChange={(e) => setOldPassword(e.target.value)}
                        required={true} />
                </div>
                {showErrorConfirmPassword != "none" && (
                    <div
                        className={eformInput}
                    >
                        <span
                            className="text-danger"
                            style={{
                                display: showErrorConfirmPassword,
                                margin: "auto",
                            }}
                        >
                            {translate(
                                "web.errorConfirmPassword",
                                "Error in Confirm Password"
                            )}
                        </span>
                    </div>
                )}
                <div className={eformInput}>
                    <NetaqInput
                        type={"password"}
                        name={"newpassword"}
                        placeholder={translate(
                            "web.newPassword",
                            "New Password"
                        )}
                        label={translate("web.newPassword", "New Password")}
                        onChange={(e) => setConfirmNewPassword(e.target.value)}
                        required={true} />
                </div>
                <div className={eformInput}>
                    <NetaqInput
                        type={"password"}
                        name={"confirmpassword"}
                        placeholder={translate(
                            "web.confirmPassword",
                            "Confirm Password"
                        )}
                        label={translate(
                            "web.confirmPassword",
                            "Confirm Password"
                        )}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required={true} />
                </div>
                <div className='d-flex px-0'>
                    <div className={saveBtnInProfile}>
                        <NewActionButton
                            isButton
                            type="submit"
                            text={translate("web.save", "Save")}
                        />
                    </div>
                </div>

            </EahsForm>
        )}

        <div className={eformCheckBox}>
            <NetaqInput
                type={"checkbox"}
                label={translate(
                    "web.agentForOtherOwner",
                    "Agent For Other Owner"
                )}
                name="agentForOtherOwner"
                checked={isAgent}
                onChange={(e) => setIsAgent(e.target.checked)}
            />
        </div>
        {isAgent && (
            <OwnerPermisions
                toast={toast}
                reloadProfile={reloadProfile}
                setActiveTab={setActiveTab}
            />
        )}
    </div>;
}
